import Roles from "@app/user/roles";

export const canViewTerminatedProviders = (roles: string[] | undefined | null): boolean =>
  roles?.includes(Roles.TERM_PROVIDER_ADMIN) === true || roles?.includes(Roles.TERM_PROVIDER_VIEWER) === true;
